export const app = {
  data () {
    return {
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    decimal: function (value, decimals) {
      if (!value) {
        value = 0
      }
      if (!decimals) {
        decimals = 0
      }
      value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
      return value
    }
  },
  methods: {
    BgImageTop (code) {
      // console.log('BgImageTop: ', code)
      if (code && code !== '') {
        let bgImage = require('@/assets/img/' + code)
        return {
          backgroundImage: `url("${bgImage}")`
        }
      }
    },
    getImgUrl (img) {
      console.log('getImgUrl: ', img)
      // return require('https://lib.pulsar.pl/img/produkty/' + img + '_1.png')
      return require('../assets/img/produkty/' + img + '_1.png')
    },
    urlImagesProduct (code) {
      var symbol = code.replace('/', ',')
      return `https://lib.pulsar.pl/img/produkty/${symbol}_1.png`
    },
    urlImagesFront (code) {
      var symbol = code.replace('/', ',')
      return `https://lib.pulsar.pl/img/konfigurator/front/${symbol}.png`
    },
    urlImagesSzafa (code) {
      var symbol = code.replace('/', ',')
      return `https://lib.pulsar.pl/img/konfigurator/szafa/${symbol}.png`
    },
    open (lang, direction, code) {
      var symbol = code.replace('/', ',')
      var strLink = 'https://lib.pulsar.pl/' + direction + '/' + lang + '/' + symbol + '.pdf'
      window.open(strLink, '_blank')
    },
    getArraysIntersection (a1, a2) {
      return a1.filter(function (n) { return a2.indexOf(n) !== -1 })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/app.js